'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _providersData = require('./providersData');

var _dataCapsule = require('data-capsule');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _consts = require('../src/applications/consts.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProviderApi = function () {
  function ProviderApi(wixApi, scope, connectedProviders, signedInstance) {
    (0, _classCallCheck3.default)(this, ProviderApi);

    if (!wixApi) {
      throw 'ProviderApi - wixAPi is empty';
    }

    this.connectedProviders = connectedProviders;
    this.providerSetOnSiteKey = 'storeProviderAlreadyConfigured';
    this.firstGalleryKey = 'isFirstGallery';
    this.dummyFirstValue = 'd';
    this.wixApi = wixApi;
    this.capsule = new _dataCapsule.DataCapsule({
      strategy: new _dataCapsule.CachedStorageStrategy({
        remoteStrategy: new _dataCapsule.WixStorageStrategy({ signedInstance: signedInstance }),
        localStrategy: new _dataCapsule.LocalStorageStrategy()
      }),
      namespace: 'artstore-' + scope
    });
  }

  (0, _createClass3.default)(ProviderApi, [{
    key: 'getConnectedProviders',
    value: function getConnectedProviders() {
      return this.connectedProviders;
    }
  }, {
    key: 'setConnectedProviders',
    value: function setConnectedProviders(connectedProviders) {
      this.connectedProviders = connectedProviders;
    }
  }, {
    key: '_getConnectedProviderId',
    value: function _getConnectedProviderId() {
      var connectedProviders = this.getConnectedProviders();
      var providerId = null;
      if (connectedProviders && (typeof connectedProviders === 'undefined' ? 'undefined' : (0, _typeof3.default)(connectedProviders)) === (0, _typeof3.default)({})) {
        providerId = (0, _keys2.default)(connectedProviders)[0];
      }
      return providerId;
    }
  }, {
    key: 'getConnectedProviderDataFromObject',
    value: function getConnectedProviderDataFromObject() {
      var connectedProviders = this.getConnectedProviders();
      var connectedProvider = null;
      var providerId = this._getConnectedProviderId();
      if (providerId) {
        connectedProvider = connectedProviders[providerId];
      }

      return connectedProvider;
    }
  }, {
    key: 'isInEditorXBM',
    value: function isInEditorXBM() {
      try {
        return window.location.origin.includes('manage.editorx');
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'getConnetedProviderActivationDataPromise',
    value: function getConnetedProviderActivationDataPromise() {
      var objConnectedProviderData = this.getConnectedProviderDataFromObject();
      var returnPromise = null;

      if (objConnectedProviderData) {
        var signedInstance = objConnectedProviderData.signedInstance,
            activationData = objConnectedProviderData.widgets.activationData;

        if (signedInstance && activationData) {
          var activationDataUrl = activationData.url;
          var options = { params: { pInstance: signedInstance } };
          if (objConnectedProviderData.providerId === _consts.privdersIds.wix) {
            //changing wix provider baseUrl for avoiding CORS when using withCredentials
            var Utils = this.wixApi.Utils;

            if (Utils && Utils.getViewMode && Utils.getViewMode() === 'editor') {
              //editor
              activationDataUrl = activationDataUrl.replace('apps.wix.com', 'progallery.wixapps.net');
              try {
                if (window.location.origin.includes('progallery.wix.com')) {
                  activationDataUrl = activationDataUrl.replace('progallery.wixapps.net', 'progallery.wix.com');
                }
              } catch (e) {}
              options.withCredentials = true;
            } else if (this.isInEditorXBM()) {
              // editor X dashboard
              activationDataUrl = activationDataUrl.replace('apps.wix.com', 'manage.editorx.com');
              options.withCredentials = true;
            } else {
              // regular dashboard
              activationDataUrl = activationDataUrl.replace('apps.wix.com', 'www.wix.com');
              options.withCredentials = true;
            }
          }
          returnPromise = _axios2.default.get(activationDataUrl, options).then(function (response) {
            return response.data;
          });
        } else {
          returnPromise = _promise2.default.reject('No activationData');
        }
      } else {
        returnPromise = _promise2.default.reject('No connectedProvider');
      }

      return returnPromise;
    }
  }, {
    key: 'getStaticProviderData',
    value: function getStaticProviderData() {
      var staticData = null;
      var providerId = this._getConnectedProviderId();
      if (providerId) {
        staticData = _providersData.providers.find(function (providerDate) {
          return providerDate.appDefId === providerId;
        });
      }
      return staticData;
    }
  }, {
    key: 'setSupportArticle',
    value: function setSupportArticle(supportType) {
      var providerId = this._getConnectedProviderId();
      try {
        if (providerId) {
          var providerStaticData = _providersData.providers.find(function (providerDate) {
            return providerDate.appDefId === providerId;
          });

          if (providerStaticData) {
            var supportId = providerStaticData.supportArticles[supportType];
            if (supportId) {
              this.wixApi.Settings.setHelpArticle(supportId, { type: 'MODAL' });
            }
          }
        }
      } catch (error) {
        console.error('Error settings support article', providerId, supportType, error);
      }
    }
  }, {
    key: 'setProviderSetOnSite',
    value: function setProviderSetOnSite() {
      return this.setItem(this.providerSetOnSiteKey, true);
    }
  }, {
    key: 'setItem',
    value: function setItem(key, value) {
      return this.capsule.setItem(key, value);
    }
  }, {
    key: 'getItem',
    value: function getItem(key) {
      return this.capsule.getItem(key);
    }
  }, {
    key: 'getProviderSetOnSite',
    value: function getProviderSetOnSite() {
      var _this = this;

      var providerSetOnSiteKey = this.providerSetOnSiteKey;
      return new _promise2.default(function (resolve) {
        _this.wixApi.Data.Public.get(providerSetOnSiteKey, { scope: 'APP' }, function (data) {
          resolve(data[providerSetOnSiteKey]);
        }, function () {
          _this.getItem(providerSetOnSiteKey).then(function (result) {
            return resolve(!!result);
          }).catch(function () {
            resolve(false);
          });
        });
      });
    }
  }, {
    key: 'getPublic',
    value: function getPublic(key) {
      var _this2 = this;

      var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'APP';

      return new _promise2.default(function (resolve, reject) {
        _this2.wixApi.Data.Public.get(key, { scope: scope }, function (data) {
          console.log('ProviderApi - getPublic', data[key]);
          resolve(data[key]);
        }, function (error) {
          console.log('ProviderApi - getPublic - error', error);
          reject(error);
        });
      });
    }
  }, {
    key: 'setPublic',
    value: function setPublic(key, value) {
      var _this3 = this;

      var scope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'APP';

      return new _promise2.default(function (resolve, reject) {
        _this3.wixApi.Data.Public.set(key, value, { scope: scope }, function (data) {
          resolve(data);
        }, function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: 'isFirstGalleryUsingCapsule',
    value: function isFirstGalleryUsingCapsule() {}
  }, {
    key: '_isFirstGallery',
    value: function _isFirstGallery(galleryId, getter, setter) {
      var firstGalleryKey = this.firstGalleryKey;
      var dummyFirstValue = this.dummyFirstValue;

      return new _promise2.default(function (resolve, reject) {
        getter(firstGalleryKey).then(function (savedGalleryId) {
          if (savedGalleryId === galleryId) {
            resolve(true);
          } else if (savedGalleryId === dummyFirstValue) {
            resolve(false);
          } else {
            setter(firstGalleryKey, dummyFirstValue).then(function () {
              resolve(false);
            });
          }
        }).catch(function () {
          reject();
        });
      });
    }
  }, {
    key: 'isFirstGallery',
    value: function isFirstGallery(galleryId) {
      var _this4 = this;

      var firstGalleryKey = this.firstGalleryKey;
      return new _promise2.default(function (resolve) {
        _this4._isFirstGallery(galleryId, function (key) {
          return _this4.getPublic(key);
        }, function (key, value) {
          return _this4.setPublic(key, value);
        }).then(function (value) {
          console.log('ProviderApi - got value from data.public', value);
          resolve(value);
        }).catch(function () {
          _this4._isFirstGallery(galleryId, function (key) {
            return _this4.getItem(key);
          }, function (key, value) {
            return _this4.setItem(key, value);
          }).then(function (value) {
            console.log('ProviderApi - got value from capsule', value);
            resolve(value);
          }).catch(function () {
            console.log('ProviderApi - settings capsule value');
            _this4.setItem(firstGalleryKey, galleryId).then(function () {
              console.log('ProviderApi - set capsule after');
              resolve(true);
            });
          });
        });
      });
    }
  }, {
    key: 'getSellerText',
    value: function getSellerText() {
      var sellerText = null;
      var statisData = this.getStaticProviderData();
      if (statisData) {
        sellerText = statisData.sellerText;
      }
      return sellerText;
    }
  }, {
    key: 'getSellTypeKey',
    value: function getSellTypeKey() {
      var key = '';
      var statisData = this.getStaticProviderData();
      if (statisData) {
        key = statisData.languageKeys.sellTypeMiniKey;
      }
      return key;
    }
  }, {
    key: 'hasAddToCart',
    value: function hasAddToCart() {
      var hasAddToCartButton = false;
      var statisData = this.getStaticProviderData();
      if (statisData) {
        hasAddToCartButton = statisData.hasAddToCartButton;
      }
      return hasAddToCartButton;
    }
  }]);
  return ProviderApi;
}();

exports.default = ProviderApi;